import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import styles from "components/settings/invite-user-modal.scss";
import { FormButton, renderFormElement } from "components/common/form-elements";
import { Button } from "components/common/button";

const StatelessInviteUserForm = ({ onCreateUser, onHideInviteUser }) => (
  <form onSubmit={ (e) => { e.preventDefault(); onCreateUser(); onHideInviteUser(); } }>
    { renderFormElement("First Name", "firstName", "text") }
    { renderFormElement("Last Name", "lastName", "text") }
    { renderFormElement("Email", "email", "text") }
    <div className={ styles["button-container"] }>
      <div className={ styles.cancel }>
        <Button link onClick={ () => onHideInviteUser() }>cancel</Button>
      </div>
      <FormButton text={ "Invite user" } />
    </div>
  </form>
);

StatelessInviteUserForm.propTypes = {
  onCreateUser: PropTypes.func.isRequired,
  onHideInviteUser: PropTypes.func.isRequired
};

export const InviteUserForm = reduxForm({ form: "inviteUserForm" })(StatelessInviteUserForm);



// WEBPACK FOOTER //
// ./src/js/components/settings/invite-user-form.jsx